<label [attr.for]="dwFor" [class.ant-form-item-required]="dwRequired">
  <ng-content></ng-content>
</label>